const API_KEY = 'f8551f5ee86aef6f4e171dfefb8720bc';

export {
    API_KEY
}